import { useEffect, useState } from "react";
import { UpsellSubscriptionContext } from "./upsell-subscription-context";
import { getPreSubscriptionData } from "./subscription-service";
import { appendSourceParameter, sendEvent } from "../../../gtm/functions";
import { IGTMEventType } from "../../../gtm/IGTMEventType";
import { useAppDispatch } from "../../redux/hooks";
import { publishModalVisibility } from "../../redux/features/modal/modalSlice";
import { prefetchPassWinners } from "@/app/hooks/usePassWinners";

const UpsellSubscriptionProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const [step, setStep] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [isMaybeLaterOpen, setIsMaybeLaterOpen] = useState(false);
  const [preSubscriptionData, setPreSubscriptionData] = useState<PreSubscriptionData>({
    features: [],
    header: {
      subtitlep1: "",
      subtitlep2: "",
      subtitlep3: "",
      title: "",
      video: "",
      videoMobile: "",
      legalText: "",
    },
    offer: {
      bonus: "",
      description: "",
      expireTime: 0,
      headline: "",
      offerImage: "",
      offerTitle: "",
    },
  });
  const [preSubscriptionDataLoading, setPreSubscriptionDataLoading] = useState<boolean>(false);

  const onNextStep = () => {
    setStep(prevState => prevState + 1);
  };

  useEffect(() => {
    prefetchPassWinners();
  }, []);

  useEffect(() => {
    if (step === 0) {
      setPreSubscriptionDataLoading(true);
      getPreSubscriptionData(false, "default")
        .then(res => res.json())
        .then(res => {
          setPreSubscriptionData(res);
          setPreSubscriptionDataLoading(false);
        })
        .catch(err => console.error(err));
    }
  }, [step]);

  const onFirstTimeMayBeLater = () => {
    setIsMaybeLaterOpen(true);
    sendEvent(IGTMEventType.SubscriptionUpsellMaybeLater, appendSourceParameter(true));
    sendEvent(IGTMEventType.SubscriptionUpsellRetentionPopupView, appendSourceParameter(true));
  };

  const onSecondTimeMayBeLater = () => {
    setIsMaybeLaterOpen(false);
    setIsModalOpen(false);
    if (step === 0) {
      setStep(1);
    }

    sendEvent(
      IGTMEventType.SubscriptionUpsellExit,
      appendSourceParameter(true, {
        eventCallback: () => {
          dispatch(publishModalVisibility({ isOpen: false }));
        },
        eventTimeout: 1000,
      })
    );
  };

  return (
    <UpsellSubscriptionContext.Provider
      value={{
        step,
        setStep,
        isModalOpen,
        setIsModalOpen,
        onNextStep,
        preSubscriptionData,
        preSubscriptionDataLoading,
        onSecondTimeMayBeLater,
        onFirstTimeMayBeLater,
        isMaybeLaterOpen,
        setIsMaybeLaterOpen,
      }}>
      {children}
    </UpsellSubscriptionContext.Provider>
  );
};

export default UpsellSubscriptionProvider;
